export default function Home() {
  return (
    <div className="fade-in">
  <h1>ロボット研究会</h1>
  <p>東京海洋大学唯一の工学サークル</p>
</div>
  );
}